/**
 * HTTP transport failure classification for fetch retries.
 * Offline sync UX copy stays in the sync module.
 */

const RETRYABLE_HTTP_STATUSES = new Set<number>([408, 429, 502, 503, 504]);

/** Response statuses that merit a retry before handling the body. */
export function isRetryableHttpResponseStatus(status: number): boolean {
  return RETRYABLE_HTTP_STATUSES.has(status);
}
